import React from "react";
import Cookies from "js-cookie";
import { Route,Redirect,withRouter } from "react-router-dom";

const Authmiddleware = ({
	component: Component,
	layout: Layout
}) => (
		<Route
			render={props => {
			
			const jwt = Cookies.get('jwt')
			
			if (!jwt) {
					return (
						<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
					);
				}
				
				return (
		     	<Layout>
						<Component {...props} />
					</Layout>
				);
			}}
		/>
	);

export default withRouter(Authmiddleware);

